import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// Home's numbers for a period of days (from, to: "YYYY-MM-DD", either may
// be missing for all time), with test accounts hidden or not by the one
// switch Cases uses. The API counts them like Cases (stats.controller.js).
export const GetStats =
  ({ callback, from, to, hideTest }) =>
  async (dispatch, getState) => {
    try {
      const data = { hide_test: !!hideTest };
      if (from) data.from = from;
      if (to) data.to = to;
      const response = await PostFunction({
        data,
        Route: UrlApi.stats.get,
        showalert: false,
        // Home says it inline, with Try again.
        showerror: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

// The Cases workspace's own counts for the same period and switch: Needs
// action, Unassigned, waiting 7+ days and who has what, so Home shows the
// numbers Cases shows.
export const GetCaseCounts =
  ({ callback, from, to, hideTest }) =>
  async (dispatch) => {
    try {
      const response = await PostFunction({
        data: { view: "needs_action", page: 0, rowsPerPage: 1, paid: "all", hide_test: !!hideTest, ...(from ? { from } : {}), ...(to ? { to } : {}) },
        Route: UrlApi.cases.list,
        showalert: false,
        showerror: false,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response?.data || null);
    } catch (err) {
      callback(null);
    }
  };

// The team (POST /stats/team): open, late and decided per person, the
// unassigned and how long open cases have waited, for the same dates and
// switch; decisions counted in decidedFrom..decidedTo (this week when none).
export const GetTeam =
  ({ callback, from, to, hideTest, decidedFrom, decidedTo }) =>
  async (dispatch) => {
    try {
      const data = { hide_test: !!hideTest };
      if (from) data.from = from;
      if (to) data.to = to;
      if (decidedFrom) data.decided_from = decidedFrom;
      if (decidedTo) data.decided_to = decidedTo;
      const response = await PostFunction({ data, Route: "stats/team", showalert: false, showerror: false, isMultipart: false, dispatch });
      callback(response?.data || null);
    } catch (err) {
      callback(null);
    }
  };

// Since yesterday (POST /stats/since): the morning check.
export const GetSince =
  ({ callback, since, hideTest }) =>
  async (dispatch) => {
    try {
      const response = await PostFunction({ data: { since, hide_test: !!hideTest }, Route: "stats/since", showalert: false, showerror: false, isMultipart: false, dispatch });
      callback(response?.data || null);
    } catch (err) {
      callback(null);
    }
  };

// Customers that look like test accounts but aren't marked (a preview).
export const GetTestSuspects =
  ({ callback }) =>
  async (dispatch) => {
    try {
      const response = await PostFunction({ data: {}, Route: "stats/test-suspects", showalert: false, showerror: false, isMultipart: false, dispatch });
      callback(response?.data || null);
    } catch (err) {
      callback(null);
    }
  };

// Marks customers as test accounts, or not (POST /clients/test; Customers'
// edit right). Resolves to the answer; throws with words to show.
export const markTestAccounts = (ids, isTest, dispatch) =>
  PostFunction({ data: { ids, is_test: isTest }, Route: "clients/test", showalert: false, showerror: false, isMultipart: false, dispatch });
